// extracted by mini-css-extract-plugin
export default {"tabs":"FiBvDcoR6D","icon":"h9c049ND+8","divider":"fZy2L+EWd0"};